module.exports = "/images/gq.svg?63ba253e9023ba10902419a668886ee2";